'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var _babelHelpers = require('../_babelHelpers-48e7a7f7.js');
var settings = require('../settings-9ee2f03f.js');

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  padding: ", ";\n  margin: ", ";\n  background-color: transparent;\n  border: 0px;\n  color: ", ";\n  ", ";\n  font-family: Source Sans Pro, sans-serif;\n  ", ";\n  &:hover,\n  :focus {\n    cursor: ", ";\n    color: ", ";\n    ", ";\n    text-decoration: ", ";\n  }\n"], ["\n  ", ";\n  ", ";\n  padding: ", ";\n  margin: ", ";\n  background-color: transparent;\n  border: 0px;\n  color: ", ";\n  ", ";\n  font-family: Source Sans Pro, sans-serif;\n  ", ";\n  &:hover,\n  :focus {\n    cursor: ", ";\n    color: ", ";\n    ", ";\n    text-decoration: ", ";\n  }\n"]),
    _templateObject2 = _babelHelpers.taggedTemplateLiteral(["\n  font-size: 18px;\n  line-height: 20px;\n  pointer-events: none;\n  ", ";\n  ", ";\n"], ["\n  font-size: 18px;\n  line-height: 20px;\n  pointer-events: none;\n  ", ";\n  ", ";\n"]);

var StyledTransparentButton = styled__default.button(_templateObject, function (props) {
  return props.flex && "display: flex";
}, function (props) {
  return props.alignItems && "align-items: " + props.alignItems;
}, function (props) {
  return props.padding ? props.padding : "1px 6px 1px 6px";
}, function (props) {
  return props.margin ? props.margin : "20px 0px 0px 0px";
}, function (props) {
  return props.color ? props.color : settings.COLOR.darkGray;
}, function (props) {
  return props.fontSize && "font-size: " + props.fontSize;
}, function (props) {
  return props.weight && "font-weight: " + props.weight;
}, function (props) {
  return props.hoverCursor ? props.hoverCursor : "pointer";
}, function (props) {
  return props.hoverColor ? props.hoverColor : settings.COLOR.gray;
}, function (props) {
  return props.hoverOpacity && "opacity: " + props.hoverOpacity;
}, function (props) {
  return props.underline || props.hoverUnderline ? true : "none";
});
var ButtonIcon = styled__default.i(_templateObject2, function (props) {
  return props.ml && "margin-left: 10px";
}, function (props) {
  return props.mr && "margin-right: 10px";
});

var TransparentButton = function TransparentButton(_ref) {
  var text = _ref.text,
      children = _ref.children,
      rest = _babelHelpers.objectWithoutProperties(_ref, ["text", "children"]);
  return React__default.createElement(
    StyledTransparentButton,
    rest,
    text && text,
    children && children
  );
};
TransparentButton.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TransparentButton"
};

exports.ButtonIcon = ButtonIcon;
exports.StyledTransparentButton = StyledTransparentButton;
exports.TransparentButton = TransparentButton;
exports.default = TransparentButton;
//# sourceMappingURL=transparent.js.map
